import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Button } from '../../../design-system';
import { ProductDetailModal } from './ProductDetailModal';
import {
  ProductCopy,
  ProductFeedback,
  ProductMedia,
  ProductSummary,
  ProductVariants,
  useProductCart,
} from './product';

interface ProductCardProps extends ProductSummary {
  explanation?: string;
  agent_chat_id?: number;
}

export const ProductCard: React.FC<ProductCardProps> = ({ explanation, agent_chat_id, ...product }) => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const cart = useProductCart(product.product_id, { agentChatId: agent_chat_id, preloadVariants: true });

  return (
    <article className="group max-w-[620px] rounded-ds-16 border border-ds-100 bg-ds-white p-3 transition-[border-color,box-shadow] hover:border-ds-200 hover:shadow-ds-2 app-sm:p-4">
      <div className="grid grid-cols-[92px_minmax(0,1fr)] gap-2.5 app-sm:grid-cols-[144px_minmax(0,1fr)] app-sm:gap-4">
        <button type="button" className="self-start overflow-hidden rounded-ds-12" onClick={() => setShowDetailModal(true)} aria-label={`${product.title || 'محصول'} رو ببین`}>
          <ProductMedia product={product} />
        </button>

        <div className="min-w-0">
          <button type="button" className="block w-full text-right" onClick={() => setShowDetailModal(true)}>
            <ProductCopy product={product} price={cart.selectedPrice} />
          </button>

          {cart.variantOptions.length > 0 && (
            <div className="mt-3">
              <ProductVariants options={cart.variantOptions} selectedId={cart.selectedVariantId} onSelect={cart.setSelectedVariantId} />
            </div>
          )}

          <div className="mt-3.5 flex flex-col gap-2 app-sm:flex-row app-sm:items-center">
            <Button
              size="sm"
              className="app-sm:mr-auto"
              onClick={() => cart.addToCart()}
              disabled={cart.addingToCart || (cart.variantOptions.length > 0 && !cart.selectedVariantId)}
            >
              {cart.addingToCart ? 'در حال افزودن...' : 'اضافه کردن به سبد خرید'}
            </Button>
          </div>
          <ProductFeedback message={cart.message} />
        </div>
      </div>

      {explanation && (
        <div className="ds-markdown mt-3 border-t border-ds-100 pt-3 text-xs">
          <ReactMarkdown>{explanation}</ReactMarkdown>
        </div>
      )}

      <ProductDetailModal
        productId={product.product_id}
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        agent_chat_id={agent_chat_id}
      />
    </article>
  );
};
